// extracted by mini-css-extract-plugin
export default {"container":"machine-relations-query_container__TCSiT","wrapper":"machine-relations-query_wrapper__1OJDh","title":"machine-relations-query_title__-f-gw"};